import React from 'react';
interface CardkeeperLogoProps {
  size?: number;
  showWordmark?: boolean;
  className?: string;
}
export function CardkeeperLogo({
  size = 120,
  showWordmark = true,
  className = ''
}: CardkeeperLogoProps) {
  // Calculate dimensions based on size
  // Base viewBox is 100x100 for the icon, plus extra height for text if needed
  const viewBoxWidth = 120;
  const viewBoxHeight = showWordmark ? 160 : 120;
  // Colors
  const colors = {
    charcoal: '#3A3A3A',
    taupe: '#B8A99A',
    offWhite: '#FAF8F5',
    shadow: 'rgba(58, 58, 58, 0.12)'
  };
  return <div className={`relative inline-flex flex-col items-center justify-center ${className}`} style={{
    width: size,
    height: showWordmark ? size * 1.33 : size
  }} data-id="element-85">
      <svg width="100%" height="100%" viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Cardkeeper Logo" role="img" data-id="element-86">
        <defs data-id="element-87">
          <filter id="soft-shadow" x="-50%" y="-50%" width="200%" height="200%" data-id="element-88">
            <feDropShadow dx="0" dy="4" stdDeviation="6" floodColor={colors.shadow} data-id="element-89" />
          </filter>
          <filter id="subtle-shadow" x="-50%" y="-50%" width="200%" height="200%" data-id="element-90">
            <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor={colors.shadow} data-id="element-91" />
          </filter>
        </defs>

        {/* Group for the card stack to center it */}
        <g transform="translate(60, 60)" data-id="element-92">
          {/* Bottom Card (Charcoal) - Base of the stack */}
          <rect x="-30" y="-20" width="60" height="40" rx="4" fill={colors.charcoal} transform="rotate(0) translate(0, 8)" filter="url(#subtle-shadow)" data-id="element-93" />

          {/* Middle Card (Taupe) - Slight rotation and offset */}
          <rect x="-30" y="-20" width="60" height="40" rx="4" fill={colors.taupe} transform="rotate(-2) translate(0, 2)" filter="url(#subtle-shadow)" data-id="element-94" />

          {/* Top Card (Off-white) - Focal point */}
          <rect x="-30" y="-20" width="60" height="40" rx="4" fill={colors.offWhite} stroke={colors.charcoal} strokeWidth="1.5" transform="rotate(1.5) translate(0, -4)" filter="url(#soft-shadow)" data-id="element-95" />
        </g>

        {/* Wordmark */}
        {showWordmark && <text x="60" y="135" textAnchor="middle" fontFamily="'DM Sans', sans-serif" fontSize="16" fontWeight="500" letterSpacing="0.02em" fill={colors.charcoal} data-id="element-96">
            Cardkeeper
          </text>}
      </svg>
    </div>;
}